import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
//helpers
import { truncate } from '../../helpers';
//custom hooks
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';

const Authors = ({ elements, originDetail = false, firstAuthorOnlyMobile = false }) => {
  const { assignedLibrary } = useAssignedLibrary();

  const formatAuthorName = (name) => {
    if (!name) return '';

    name = name.trim();

    if (name.includes(',')) {
      const [last, first] = name.split(',').map(part => part.trim());
      name = `${first} ${last}`;
    }

    return name
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
  const hideOnMobileClass = firstAuthorOnlyMobile ? ' d-none d-md-inline' : '';

  return (
    <div className="store-item-authors">
      {elements?.map((value, i) => (
        <React.Fragment key={`authors${i}`}>
          {i > 0 && firstAuthorOnlyMobile && <span className="d-none d-md-inline">, </span>}
          <Link
            className={`store-item-authors__link${originDetail ? '-detail' : ''}${i > 0 ? hideOnMobileClass : ''}`}
            to={`/${assignedLibrary}/autor/${value.url}/`}
            state={value.nombre_autor}
          >
            {formatAuthorName(value.nombre_autor)}
          </Link>
          {i < elements.length - 1 && !firstAuthorOnlyMobile && ', '}
        </React.Fragment>
      ))}
    </div>
  );
};

Authors.propTypes = {
  elements: PropTypes.array,
  originDetail: PropTypes.bool,
  firstAuthorOnlyMobile: PropTypes.bool
};

export default Authors;
